import axios from 'axios';

const getByCurp = (curp = ``, captchaToken) =>
  axios.get(`open/identity/${curp}`, { params: { captchaToken } });

const createRegistro = (values, captchaToken) =>
  axios.post(`open/identity`, values, { params: { captchaToken } });

export { getByCurp, createRegistro };
